export default {
  id: "catering-dietary-restrictions",
  name: "Dietary Restrictions",
  settings: {}
};
